@for (group of variantGroups(); track group.attributeId) {
  <div
    class="variants-group"
    [class.variants-group-big]="isBigSize()"
  >
    <!-- Swatches on a card need no label -->
    @if (isBigSize() || !group.hasColor) {
      <div
        class="variants-group-label-container"
        [class.variants-group-label-container-big]="isBigSize()"
      >
        <!-- On one line: a break before the colon would render as a space -->
        <span class="variants-group-label">{{ group.label }}</span>@if (isBigSize()) {:
          <span class="variants-group-selected">{{ group.selectedVariantLabel }}</span>
        }
      </div>
    }
    <div class="variants-group-variants">
      @for (variant of visibleVariants(group); track variant.valueId) {
        <a
          class="variants-group-variant g-tooltip-container"
          [class.variants-group-variant-big]="isBigSize()"
          [routerLink]="['/', variant.slug]"
          [attr.aria-current]="variant.isSelected ? 'true' : null"
          [attr.aria-label]="group.label + ': ' + variant.label"
          (mouseenter)="variantHover.emit(variant)"
          (focus)="variantHover.emit(variant)"
          routerLinkWithLang
        >
          @if (group.hasColor) {
            <span
              class="variants-group-color-container"
              [class.variants-group-color-container-big]="isBigSize()"
              [class.variants-group-color-container-selected]="variant.isSelected"
              [class.variants-group-color-container-out-of-stock]="!variant.isInStock"
              [class.variants-group-jump]="variant.changesOtherAxes"
            >
              <span
                class="variants-group-color"
                [class.variants-group-color-big]="isBigSize()"
                [style.background]="swatchBackground(variant)"
              ></span>
            </span>
          } @else {
            <span
              class="variants-group-variant-label"
              [class.variants-group-variant-label-big]="isBigSize()"
              [class.variants-group-variant-label-selected]="variant.isSelected"
              [class.variants-group-variant-label-out-of-stock]="!variant.isInStock"
              [class.variants-group-jump]="variant.changesOtherAxes"
            >
              {{ variant.label }}
            </span>
          }
          <!-- On a list card the title and image already follow the hovered swatch; the current one is named above -->
          @if (isBigSize() && !variant.isSelected && (group.hasColor || variant.changesOtherAxes || !variant.isInStock)) {
            <span class="g-tooltip g-tooltip-no-min-width variants-group-tooltip">
              @if (group.hasColor) {
                <span class="variants-group-tooltip-line">{{ variant.label }}</span>
              }
              @if (variant.changesOtherAxes) {
                <span class="variants-group-tooltip-line">{{ 'product.variant_combination_missing' | translate }}</span>
                <span class="variants-group-tooltip-line variants-group-tooltip-note">
                  {{ 'product.variant_changes_other' | translate: { values: variant.changedValuesLabel } }}
                </span>
              }
              @if (!variant.isInStock) {
                <span class="variants-group-tooltip-line">{{ 'global.out_of_stock' | translate }}</span>
              }
            </span>
          }
        </a>
      }
      @if (moreSlug() && group.variantsTotal > group.variants.length) {
        <a
          class="variants-group-more g-main-link"
          [routerLink]="['/', moreSlug()]"
          routerLinkWithLang
        >
          +{{ group.variantsTotal - group.variants.length }}
        </a>
      }
      @if (isFoldable(group)) {
        <button
          class="variants-group-toggle g-main-link"
          (click)="toggleGroup(group)"
          type="button"
        >
          @if (expandedGroupIds().has(group.attributeId)) {
            {{ 'product.fewer_colors' | translate }}
          } @else {
            {{ 'product.all_colors' | translate: { count: group.variants.length } }}
          }
        </button>
      }
    </div>
  </div>
}
